module.exports = global["rpBreakpoints"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./~/rp-mq-breakpoints/lib/index.js
// module id = 91
// module chunks = 0